import React from "react";
import Map from "../../left_component/Map";

const Search = () => {
  return <Map />;
};

export default Search;
